import Rate from './Rate';

export default Rate;
export { Rate };
export type { RateProps } from './type';
